import { render } from "./SubaruFlexSpaceBanner.vue?vue&type=template&id=565a26ca"
import script from "./SubaruFlexSpaceBanner.vue?vue&type=script&lang=js"
export * from "./SubaruFlexSpaceBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/SubaruFlexSpaceBanner/SubaruFlexSpaceBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565a26ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565a26ca', __exports__)) {
    api.reload('565a26ca', __exports__)
  }
  
  module.hot.accept("./SubaruFlexSpaceBanner.vue?vue&type=template&id=565a26ca", () => {
    api.rerender('565a26ca', render)
  })

}


export default __exports__